import { createSlice } from '@reduxjs/toolkit';
import axios from '../../utils/axios';

const initialState = {
  ledger: [],
  expense: [],
  invoice: [],
  nature: [],
  expenseEdit: [],
  tab: 'expense',
  tabJournal: 'Expense',
  expenseWithPaymentAll: [],
  expenseSetting: [],
  invoiceExpense: '',
  journalSetting: [],
  invoiceJournal: '',
  fixedSetting: [],
  invoiceFixed: '',
  SupplierPartyName: [],

  invoiceExp: [],

  expenseWithPaymenteEdit: [],
  journalExpense: [],
  journalInvoice: [],
  journalNature: [],
  natureJournal: [],
  journalExpenseEdit: [],
  journalLegder: [],
  fixExpense: [],
  fixNewExpense: [],
  fixedAssetAllIncomeTax: [],
  fixInvoice: [],
  fixNature: [],
  fixExpenseEdit: [],
  fixLegder: [],
  FixedAssetsNature: [],
  RateOfDepreciations: [],
  expenseSummary: null,
  journal: [],
  expenseAllSummary: [],
  journalSummary: [],
  fixAssetsSummary: [],
  expenseVoucherNo: [],
  expenseJSetting: [],

  isLoading: true,
};

const slice = createSlice({
  name: 'expense',
  initialState,
  reducers: {
    setPdf(state, action) {
      state.pdf = action.payload;
    },
    setIsLoading(state, action) {
      state.isLoading = action.payload;
    },
    setTab(state, action) {
      state.tab = action.payload;
    },
    setExpenseEdit(state, action) {
      state.expenseEdit = action.payload;
    },
    setLedger(state, action) {
      state.ledger = action.payload;
    },
    setExpense(state, action) {
      state.expense = action.payload;
    },
    setInvoice(state, action) {
      state.invoice = action.payload;
    },
    setNature(state, action) {
      state.nature = action.payload;
    },
    setFixExpenseEdit(state, action) {
      state.fixExpenseEdit = action.payload;
    },
    setFixNature(state, action) {
      state.fixNature = action.payload;
    },
    setFixLegder(state, action) {
      state.fixLegder = action.payload;
    },
    setFixedAssetsNature(state, action) {
      state.FixedAssetsNature = action.payload;
    },
    setNatureJournal(state, action) {
      state.natureJournal = action.payload;
    },
    setRateOfDepreciations(state, action) {
      state.RateOfDepreciations = action.payload;
    },
    setInvoiceFixed(state, action) {
      state.invoiceFixed = action.payload;
    },
    setInvoiceJournal(state, action) {
      state.invoiceJournal = action.payload;
    },
    setTabJournal(state, action) {
      state.tabJournal = action.payload;
    },
    setFixAssetsSummary(state, action) {
      state.fixAssetsSummary = action.payload;
    },
    setJournal(state, action) {
      state.journal = action.payload;
    },
    setJournalSummary(state, action) {
      state.journalSummary = action.payload;
    },
    setNewFixExpense(state, action) {
      state.fixNewExpense = action.payload;
    },
    setExpenseVoucherNo(state, action) {
      state.expenseVoucherNo = action.payload;
    },
    setExpenseWithPaymenteEdit(state, action) {
      state.expenseWithPaymenteEdit = action.payload;
    },
    setSupplierPartyName(state, action) {
      state.SupplierPartyName = action.payload;
    },
    setInvoiceExpense(state, action) {
      state.invoiceExpense = action.payload;
    },
    setExpenseSetting(state, action) {
      state.expenseSetting = action.payload;
    },
    setExpenseJSetting(state, action) {
      state.expenseJSetting = action.payload;
    },
    setFixedSetting(state, action) {
      state.fixedSetting = action.payload;
    },
    setJournalSetting(state, action) {
      state.journalSetting = action.payload;
    },
    setExpenseSummary(state, action) {
      state.expenseSummary = action.payload;
    },
    setExpenseWithPaymentAll(state, action) {
      state.expenseWithPaymentAll = action.payload;
    },
    setExpenseAllSummary(state, action) {
      state.expenseAllSummary = action.payload;
    },
  },
});

export default slice.reducer;

export const {
  setPdf,
  setIsLoading,
  setLedger,
  setExpense,
  setInvoice,
  setNature,
  setExpenseEdit,
  setTab,
  setFixExpenseEdit,
  setFixNature,
  setFixLegder,
  setFixedAssetsNature,
  setNatureJournal,
  setRateOfDepreciations,
  setInvoiceFixed,
  setInvoiceJournal,
  setTabJournal,
  setFixAssetsSummary,
  setJournal,
  setJournalSummary,
  setNewFixExpense,
  setExpenseVoucherNo,
  setExpenseWithPaymenteEdit,
  setSupplierPartyName,
  setInvoiceExpense,
  setExpenseSetting,
  setExpenseJSetting,
  setFixedSetting,
  setJournalSetting,
  setExpenseSummary,
  setExpenseWithPaymentAll,
  setExpenseAllSummary,
} = slice.actions;

export const getExpenseAllSummary = (sd, ed) => async (dispatch) => {
  try {
    await axios
      .get(`/expense/All_expense_summry?start_date=${sd}&end_date=${ed}`)
      .then((response) => dispatch(setExpenseAllSummary(response.data)));
  } catch (error) {
    return console.error(error.message);
  }
  return true;
};

export const getExpenseWithPaymentAll = (sd, ed, p, r, s, t) => async (dispatch) => {
  try {
    dispatch(setIsLoading(true));
    await axios
      .get(
        `/expense/ExpenseWithPaymentAll?start_date=${sd}&end_date=${ed}&pagination=${p}&records=${r}&search=${s}&type=${t}`
      )
      .then((response) => dispatch(setExpenseWithPaymentAll(response.data)));
    dispatch(setIsLoading(false));
  } catch (error) {
    dispatch(setIsLoading(false));
    return console.error(error.message);
  }
  return true;
};

export const getExpenseSummary = (sd, ed) => async (dispatch) => {
  try {
    await axios
      .get(`/expense/summary/EXP?start_date=${sd}&end_date=${ed}`)
      .then((response) => dispatch(setExpenseSummary(response.data)));
  } catch (error) {
    return console.error(error.message);
  }
  return true;
};

export const getJournalSetting = () => async (dispatch) => {
  try {
    await axios.get('/Journal/JournalSettings').then((response) => dispatch(setJournalSetting(response.data)));
  } catch (error) {
    return console.error(error.message);
  }
  return true;
};

export const getFixedSetting = () => async (dispatch) => {
  try {
    await axios.get('/fixedAsset/FixedAssetSettings').then((response) => dispatch(setFixedSetting(response.data)));
  } catch (error) {
    return console.error(error.message);
  }
  return true;
};

export const getExpenseJSetting = () => async (dispatch) => {
  try {
    await axios.get('/expense/Expense_Settings').then((response) => dispatch(setExpenseJSetting(response.data)));
  } catch (error) {
    return console.error(error.message);
  }
  return true;
};

export const getExpenseSetting = () => async (dispatch) => {
  try {
    await axios
      .get('/expense/ExpenseWithPaymentSettings')
      .then((response) => dispatch(setExpenseSetting(response.data)));
  } catch (error) {
    return console.error(error.message);
  }
  return true;
};

export const getinvoiceExpense = () => async (dispatch) => {
  try {
    await axios
      .get('/expense/ExpenseWithPayment_VoucherNo/')
      .then((response) => dispatch(setInvoiceExpense(response.data)));
  } catch (error) {
    return console.error(error.message);
  }
  return true;
};

export const getSupplierPartyName = (id) => async (dispatch) => {
  try {
    await axios.get(`/expense/SupplierPartyName`).then((response) => dispatch(setSupplierPartyName(response.data)));
  } catch (error) {
    return console.error(error.message);
  }
  return true;
};

export const ExpenseWithPaymentEdit = (id) => async (dispatch) => {
  try {
    await axios
      .get(`/expense/ExpenseWithPayment?ID=${id}`)
      .then((response) => dispatch(setExpenseWithPaymenteEdit(response.data)));
  } catch (error) {
    return console.error(error.message);
  }
  return true;
};

export const getExpenseVoucherNo = (sd, ed) => async (dispatch) => {
  try {
    await axios.get('/expense/Expense_VoucherNo/').then((response) => dispatch(setExpenseVoucherNo(response.data)));
  } catch (error) {
    return console.error(error.message);
  }
  return true;
};

export const getNewFixExpense = (sd, ed) => async (dispatch) => {
  try {
    dispatch(setIsLoading(true));
    // await axios .get(`/ledger-partyAll?start=${startDate || ''}&end=${endDate || ''}`).then((response) => dispatch(setNewLedger(response.data)));
    await axios
      .get(`/fixedAsset/NewfixedAssetAll?start=${sd}&end=${ed}`)
      .then((response) => dispatch(setNewFixExpense(response.data)));
    dispatch(setIsLoading(false));
  } catch (error) {
    dispatch(setIsLoading(false));

    return console.error(error.message);
  }
  return true;
};

export const getJournalSummary = (sd, ed) => async (dispatch) => {
  try {
    await axios
      .get(`/expense/summary_journal?start_date=${sd}&end_date=${ed}`)
      .then((response) => dispatch(setJournalSummary(response.data)));
  } catch (error) {
    return console.error(error.message);
  }
  return true;
};

export const getJournal = (sd, ed, p, r, s, t) => async (dispatch) => {
  try {
    dispatch(setIsLoading(true));
    await axios
      .get(`/expense/journalAll?start_date=${sd}&end_date=${ed}&pagination=${p}&records=${r}&search=${s}&type=${t}`)
      .then((response) => dispatch(setJournal(response.data)));
    dispatch(setIsLoading(false));
  } catch (error) {
    dispatch(setIsLoading(false));

    return console.error(error.message);
  }
  return true;
};

export const getFixAssetsSummary = (sd, ed) => async (dispatch) => {
  try {
    await axios
      .get(`/fixedAsset/fixedAssetAllIncomeTax_summary?start=${sd}&end=${ed}`)
      .then((response) => dispatch(setFixAssetsSummary(response.data)));
  } catch (error) {
    return console.error(error.message);
  }
  return true;
};

export const getinvoiceJournal = () => async (dispatch) => {
  try {
    await axios.get('/Journal/Journal_VoucherNo/').then((response) => dispatch(setInvoiceJournal(response.data)));
  } catch (error) {
    return console.error(error.message);
  }
  return true;
};

export const getinvoiceFixed = () => async (dispatch) => {
  try {
    await axios.get('/fixedAsset/FixedAsset_VoucherNo/').then((response) => dispatch(setInvoiceFixed(response.data)));
  } catch (error) {
    return console.error(error.message);
  }
  return true;
};

export const getRateOfDepreciations = (id, cb) => async (dispatch) => {
  try {
    await axios.get(`/fixedAsset/RateOfDepreciations?categoryID=${id}`).then((response) => {
      cb?.(response?.data);
      dispatch(setRateOfDepreciations(response.data));
    });
  } catch (error) {
    return console.error(error.message);
  }
  return true;
};

export const getNatureJournal = () => async (dispatch) => {
  try {
    await axios.get('/expense/Journalnature').then((response) => dispatch(setNatureJournal(response.data)));
  } catch (error) {
    return console.error(error.message);
  }
  return true;
};

export const getFixedAssetsNature = () => async (dispatch) => {
  try {
    await axios.get('/fixedAsset/FixedAssetsNature').then((response) => dispatch(setFixedAssetsNature(response.data)));
  } catch (error) {
    return console.error(error.message);
  }
  return true;
};

export const getFixParty = () => async (dispatch) => {
  try {
    dispatch(setIsLoading(true));
    await axios.get('/fixedAsset/partyName').then((response) => dispatch(setFixLegder(response.data)));
    dispatch(setIsLoading(false));
  } catch (error) {
    dispatch(setIsLoading(false));

    return console.error(error.message);
  }
  return true;
};

export const getFixNature = () => async (dispatch) => {
  try {
    dispatch(setIsLoading(true));
    await axios.get('/fixedAsset/nature').then((response) => dispatch(setFixNature(response.data)));
    dispatch(setIsLoading(false));
  } catch (error) {
    dispatch(setIsLoading(false));

    return console.error(error.message);
  }
  return true;
};

export const getFixExpenseEdit = (id) => async (dispatch) => {
  try {
    await axios.get(`/fixedAsset/fixedAsset?ID=${id}`).then((response) => dispatch(setFixExpenseEdit(response.data)));
  } catch (error) {
    return console.error(error.message);
  }
  return true;
};

export const getParty = () => async (dispatch) => {
  try {
    await axios.get('/expense/partyName').then((response) => dispatch(setLedger(response.data)));
  } catch (error) {
    return console.error(error.message);
  }
  return true;
};

export const getExpense = (sd, ed, p, r, s, t) => async (dispatch) => {
  try {
    dispatch(setIsLoading(true));
    await axios
      .get(`/expense/expenseAll?start_date=${sd}&end_date=${ed}&pagination=${p}&records=${r}&search=${s}&type=${t}`)
      .then((response) => dispatch(setExpense(response.data)));
    dispatch(setIsLoading(false));
  } catch (error) {
    dispatch(setIsLoading(false));

    return console.error(error.message);
  }
  return true;
};

export const getNature = () => async (dispatch) => {
  try {
    await axios.get('/expense/nature').then((response) => dispatch(setNature(response.data)));
  } catch (error) {
    return console.error(error.message);
  }
  return true;
};

export const getInvoice = (id) => async (dispatch) => {
  try {
    await axios.get(`/expense/invoices?ledger_ID=${id}`).then((response) => dispatch(setInvoice(response.data)));
  } catch (error) {
    return console.error(error.message);
  }
  return true;
};

export const getExpenseEdit = (id) => async (dispatch) => {
  try {
    await axios.get(`/expense/expense?ID=${id}`).then((response) => dispatch(setExpenseEdit(response.data)));
  } catch (error) {
    return console.error(error.message);
  }
  return true;
};
